import { Loader2 } from "lucide-react";
import { BackButton } from "@/v2/components/BackButton";
import { StripePaymentForm } from "@/v2/components/StripePaymentForm";

export function StepPayment({
  clientSecret,
  returnUrl,
  planPrice,
  onBack,
  onSuccess,
  onError,
  onBeforeConfirm,
}: {
  clientSecret: string | null;
  returnUrl: string;
  planPrice: number;
  onBack: () => void;
  onSuccess: () => void;
  onError: (message: string) => void;
  onBeforeConfirm: () => void;
}) {
  return (
    <div className="space-y-6">
      <div>
        <BackButton onClick={onBack} />
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-foreground">
          Payment
        </h1>
        <p className="text-sm mt-1 max-w-xl text-muted-foreground">
          Review your order and complete your payment. The gift will be sent
          after your payment is processed.
        </p>
      </div>

      <div
        className="bg-card border border-border rounded-2xl shadow-xs"
        style={{ padding: "24px" }}
      >
        {clientSecret ? (
          <StripePaymentForm
            clientSecret={clientSecret}
            returnUrl={returnUrl}
            onSuccess={onSuccess}
            onError={onError}
            onBeforeConfirm={onBeforeConfirm}
            submitLabel={`Complete Purchase - $${planPrice.toFixed(2)}`}
            processingLabel="Processing payment..."
          />
        ) : (
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground py-8">
            <Loader2 className="size-4 animate-spin" /> Preparing secure
            payment...
          </div>
        )}
      </div>
    </div>
  );
}
